package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AutomationTestRunResponse(
    val id: String,
    val environment: String,
    val status: String,
    val suites: String,
    @SerialName("total_tests") val totalTests: Int,
    @SerialName("passed_tests") val passedTests: Int,
    @SerialName("failed_tests") val failedTests: Int,
    @SerialName("triggered_by") val triggeredBy: String? = null,
    @SerialName("started_at_utc") val startedAtUtc: String,
    @SerialName("finished_at_utc") val finishedAtUtc: String? = null,
    @SerialName("created_at_utc") val createdAtUtc: String
)
